export default {
    colors: [
        '#E4003F', // Primary red
        '#393634', // Primary dark
        '#817979', // Primary dark 49
        '#0078C2', // Delta blue 38
        '#108965', // green 30
    ],

    chart: {
        backgroundColor: '#F0EFEF',
    },

    exporting: {
        buttons: {
            contextButton: {
                symbolStroke: 'rgba(57, 54, 52, 0.6)',
                theme: {
                    fill: '#F0EFEF' // Background color of the burger menu
                }
            }
        }
    },

    title: {
        style: {
            color: '#E4003F',
            fontSize: 44,
            fontWeight: 700,
            fontFamily: "BuenosAiresOffice, Arial, sans-serif"
        }
    },

    subtitle: {
        style: {
            color: '#393634',
            fontSize: 18,
            fontFamily: "BuenosAiresOffice, Arial, sans-serif"
        }
    },

    legend: {
        itemStyle: {
            color: '#393634',
            fontSize: 12,
            fontFamily: "BuenosAiresOffice, Arial, sans-serif"
        },
        itemHoverStyle: {
            color: '#262524'
        }
    },

    tooltip: {
        headerFormat: '<span style="font-size: 18px;">{point.key}</span><br/>',
        style: {
            fontSize: 14,
            fontFamily: "BuenosAiresOffice, Arial, sans-serif"
        }
    },

    xAxis: {
        crosshair: {
            color: '#D7D2CB', // diagrams hover background color
        },
        title: {
            style: {
                color: '#393634',
                fontSize: 12,
                fontWeight: 700
            }
        },
        labels: {
            style: {
                color: '#393634',
                fontSize: 12,
            }
        }
    },

    yAxis: {
        crosshair: {
            color: '#D7D2CB', // diagrams hover background color
        },
        title: {
            style: {
                color: '#393634',
                fontSize: 12,
                fontWeight: 700
            }
        },
        labels: {
            style: {
                color: '#393634',
                fontSize: 12
            }
        }
    },
    lang: {
        thousandsSep: '.'
    },
    credits: {
        enabled: false
    }
};
